import { render, staticRenderFns } from "./AS_SmartPrepaidBalanceold.vue?vue&type=template&id=2396f8c5&scoped=true&"
import script from "./AS_SmartPrepaidBalanceold.vue?vue&type=script&lang=js&"
export * from "./AS_SmartPrepaidBalanceold.vue?vue&type=script&lang=js&"
import style0 from "./AS_SmartPrepaidBalanceold.vue?vue&type=style&index=0&id=2396f8c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396f8c5",
  null
  
)

export default component.exports